import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getWebConfigSelector } from '../../../../../settings/selectors/webConfigSelector';

import ChangeTheme from './ChangeTheme';

const mapStateToProps = createStructuredSelector({
    webConfiguration: getWebConfigSelector
});

export default connect(mapStateToProps)(ChangeTheme);
